import { render, staticRenderFns } from "./SoundCouples.vue?vue&type=template&id=fbdd5540&lang=pug&"
import script from "./SoundCouples.vue?vue&type=script&lang=js&"
export * from "./SoundCouples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports